import _ from 'lodash';
import useEntities from 'new/state/entities/repository/useEntities';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { sortByDisplayOrder } from 'new/utils/displayOrder';

export default function useLLMFields(selectedConnection: string) {
  const { data: vendorEndpoints } = useEntities('vendorEndpoints');
  const fields = useSelector((state: any) => state.paging.llmConfigById[selectedConnection]) || [];

  return useMemo(() => {
    const endpointField = _.find(fields, { name: 'vendor_endpoint_id' });

    const filteredFields = fields.filter((field) => field.name !== 'vendor_endpoint_id');

    const endpoints: any[] = sortByDisplayOrder(
      Object.values(vendorEndpoints).filter((endpoint: any) => {
        if (!endpointField) return false;
        return (
          endpointField?.options.find((v) => v.value === endpoint.id) && endpoint?.config?.isLLM
        );
      }) as any[],
    );
    return {
      endpoint: endpoints[0],
      filteredFields,
    };
  }, [fields]);
}
